import API from "../api";

export const getJenisUji = () => API.get("/jenis-uji");
export const addJenisUji = (data) => API.post("/jenis-uji", data);
export const updateJenisUji = (id, data) => API.put(`/jenis-uji/${id}`, data);
export const deleteJenisUji = (id) => API.delete(`/jenis-uji/${id}`);
